module.exports = __webpack_public_path__ + "img/nmi.0162d044.png";